import React from 'react';
import { useIntl } from 'react-intl';

import { Checkbox, CheckboxProps } from 'carbon-react/lib/components/checkbox';

import { ForecastFormElementIds } from '../../types';

export type ForecastPreviousActualsProps = Omit<CheckboxProps, 'name' | 'id' | 'label' | 'inputHint'>;

export const ForecastPreviousActuals = (props: ForecastPreviousActualsProps) => {
  const intl = useIntl();

  return (
    <Checkbox
      name={ForecastFormElementIds.PreviousActuals}
      id={ForecastFormElementIds.PreviousActuals}
      label={intl.formatMessage({
        id: 'predict.create_forecast.display_previous_actuals',
        defaultMessage: 'Display previous actuals?'
      })}
      inputHint={intl.formatMessage({
        id: 'predict.create_forecast.display_previous_actuals_hint',
        defaultMessage:
          'Selecting this option will display actual data for two full financial years plus the current financial year, up until the last completed sync'
      })}
      {...props}
    />
  );
};
